import React, { useContext, useEffect } from 'react'
import { Form, Field } from 'react-final-form'
import formStyles from 'styles/form.module.scss'
import modalStyles from 'styles/modal.module.scss'
import 'styles/beginForm.scss'
import { ModalContext } from 'providers/Modal'
import Close from './common/Close'
import { trackLoginFormOpen } from 'analytics/ga'
import { domainName, formattedDomainName, baseUrl } from 'utils/parseDomain'

const onSubmit = async values => {
  document.getElementById('frmLogin').submit()
}

const FormHeader = () => (
  <div data-testid="form_header" className={formStyles.header}>
    <img
      src="https://img2.shaadi.com/assests/2016/images/home-page-layer-logo.png"
      alt="Login to shaadi.com"
      style={{
        margin: '9px auto 30px',
        height: '87px',
        width: '87px',
      }}
    />
    <h2 className={`${formStyles.formTitle} ${formStyles.loginFormTitle}`}>
      Welcome back!
      <br />
      Please Login
    </h2>
  </div>
)

const EmailOrMobile = () => (
  <Field name="email">
    {({ input, meta }) => (
      <div className={`form-group col-md-12 ${formStyles.formEleWrap}`}>
        <label htmlFor="login_email" className={formStyles.layerLable}>
          Mobile No. / Email ID
        </label>
        <input
          data-testid="login_email"
          className={`form-control ${formStyles.formTextFreeField}`}
          type="text"
          {...input}
        />
        {meta.touched && meta.error && <span>{meta.error}</span>}
      </div>
    )}
  </Field>
)

const Password = () => (
  <Field name="password">
    {({ input, meta }) => (
      <div className={`form-group col-md-12 ${formStyles.formEleWrap}`}>
        <label htmlFor="login_password" className={formStyles.layerLable}>
          Password
        </label>
        <input
          data-testid="login_password"
          className={`form-control ${formStyles.formTextFreeField}`}
          type="password"
          {...input}
        />
        {meta.touched && meta.error && <span>{meta.error}</span>}
      </div>
    )}
  </Field>
)

const LoginButton = () => (
  <button
    data-testid="sign_in"
    className={`btn btn-primary btn-md btn-block ${formStyles.signIn}`}
    type="submit"
  >
    Sign In
  </button>
)

const AutoLogin = ({ values }) => (
  <Field name="autologin" type="checkbox">
    {({ input, meta }) => (
      <div
        data-testid="autologin"
        className={`form-group col-md-12 ${formStyles.formEleWrap}`}
      >
        <div className="form-check form-check-inline" style={{ width: '100%' }}>
          <input
            data-testid="stay_signed_in"
            className="form-check-input"
            type="checkbox"
            checked={values.autologin ? 'checked' : ''}
            style={{ marginRight: '5px' }}
            {...input}
          />
          <label className={`form-check-label ${formStyles.staySignInLable}`}>
            Stay Signed in
          </label>
          <div
            data-testid="stay_signed_in_tooltip"
            className={`${formStyles.loginHelp} ${formStyles.tooltip}`}
          >
            <span className={formStyles.tooltiptext}>
              We recommend that you do not use this feature if you are signing
              in from a shared computer.
            </span>
          </div>
          <a
            data-testid="forgot_password"
            href={`https://my.${domainName}/forgot-password/user`}
            className={formStyles.forgotPwdLink}
            style={{ marginLeft: 'auto' }}
          >
            Forgot Password?
          </a>
        </div>
      </div>
    )}
  </Field>
)

const SignupLink = ({ switchForm }) => (
  <p className={modalStyles.switcher}>
    New to {formattedDomainName}?<br />
    <a
      data-testid="sign_up_free"
      onClick={() => switchForm('register')}
      href="javascript:void(0)"
    >
      Sign Up Free
    </a>
  </p>
)

const Login = () => {
  const { setActive } = useContext(ModalContext)
  const switchForm = formId => {
    setActive(formId)
  }

  useEffect(() => {
    trackLoginFormOpen()
  })
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ autologin: true }}
      render={({ handleSubmit, pristine, invalid, values }) => (
        <form
          className={formStyles.wrapper}
          onSubmit={handleSubmit}
          data-testid="login_form"
          id="frmLogin"
          name="frmLogin"
          action={`${baseUrl}/registration/user/login-submit`}
          method="POST"
        >
          <Close />
          <div className="form-row">
            <FormHeader />

            <EmailOrMobile />
            <Password />
            <AutoLogin values={values} />

            <LoginButton />
            <SignupLink switchForm={switchForm} />
          </div>
        </form>
      )}
    />
  )
}

export default Login
